export const defaultFilterData = {
	airlineDetails: {
		AB: 'Air Berlin',
		AF: 'Air France',
		AY: 'Finnair',
		BA: 'British Airways Shuttle',
		BT: 'Air Baltic',
		D8: 'Norwegian',
		DY: 'Norwegian',
		EW: 'Eurowings',
		FR: 'Ryanair',
		KL: 'KLM',
		LG: 'Luxair',
		LH: 'Lufthansa',
		LO: 'LOT',
		LX: 'Swiss',
		OS: 'Austrian Airlines',
		PS: 'Ukraine Int. Airlines',
		SK: 'SAS',
		SN: 'Brussels Airlines',
		U2: 'EasyJet',
		W6: 'Wizz Air'
	},
	airlineMissing: [
		'9B'
	],
	airportDetails: {
		ARN: {
			airport: 'Arlanda',
			city: 'Stockholm',
			country: 'Sverige',
			latitude: '59.65194',
			longitude: '17.91861',
			utc: '+01:00'
		},
		GOT: {
			airport: 'Landvetter',
			city: 'G\u00F6teborg',
			country: 'Sverige',
			latitude: '57.66283',
			longitude: '12.27981',
			utc: '+01:00'
		},
		LCY: {
			airport: 'City',
			city: 'London',
			country: 'Storbritannien',
			latitude: '51.50527',
			longitude: '0.055278',
			utc: '+00:00'
		}
	},
	airportPriceMap: {
		arrivals: {
			LCY: 3113
		},
		departures: {
			ARN: 844
		},
		stops: {
			GOT: 916
		}
	},
	alliance: {
		AB: 'oneworld alliance',
		AF: 'skyteam alliance',
		AY: 'oneworld alliance',
		BA: 'oneworld alliance',
		KL: 'skyteam alliance',
		LH: 'star alliance',
		LO: 'star alliance',
		LX: 'star alliance',
		OS: 'star alliance',
		SK: 'star alliance',
		SN: 'star alliance'
	},
	allianceToAirlines: {
		alliancefree: [
			'FR',
			'D8',
			'DY',
			'W6',
			'PS',
			'BT',
			'U2',
			'EW',
			'LG'
		],
		'oneworld alliance': [
			'BA',
			'AY',
			'AB'
		],
		'skyteam alliance': [
			'KL',
			'AF'
		],
		'star alliance': [
			'SK',
			'SN',
			'LX',
			'OS',
			'LH',
			'LO'
		]
	},
	equipment: {
		319: 'Airbus A319',
		E95: 'Embraer E195'
	},
	foreign: [
		'kiwi',
		'flyhi',
		'travelgenio',
		'travel2be',
		'tripsta'
	],
	mobilefriendly: [
		'supersaver',
		'2fly',
		'seat24',
		'travelstart',
		'kiwi',
		'flyhi',
		'airngo',
		'resecentrum',
		'ticket',
		'sembo',
		'travelgenio',
		'travel2be',
		'flygcity',
		'aobtravel',
		'oden',
		'norwegian',
		'mytrip',
		'flygpoolen',
		'travelstore',
		'flightfinder',
		'tripsta',
		'sas'
	],
	travelAgent: {
		se_2fly: '2fly',
		se_airngo: 'airngo',
		se_aobtrav: 'aobtravel',
		se_flightfinder: 'flightfinder',
		se_flygcen: 'supersaver',
		se_flygcity: 'flygcity',
		se_flygpln: 'flygpoolen',
		se_flyhi: 'flyhi',
		se_kiwi: 'kiwi',
		se_mytrip: 'mytrip',
		se_norwegian: 'norwegian',
		se_oden: 'oden',
		se_resecentrum: 'resecentrum',
		se_resfeber: 'resfeber',
		se_resia: 'resia',
		se_sas: 'sas',
		se_seat24: 'seat24',
		se_sembo: 'sembo',
		se_ticket: 'ticket',
		se_travel2be: 'travel2be',
		se_travelgenio: 'travelgenio',
		se_tripsta: 'tripsta',
		se_trstore: 'travelstore',
		se_tvlstrt: 'travelstart'
	},
	travelAgentID: {
		'2fly': '19',
		airngo: '80',
		aobtravel: '10',
		flightfinder: '36',
		flygcity: '31',
		flygpoolen: '18',
		flyhi: '67',
		kiwi: '45',
		mytrip: '46',
		norwegian: '33',
		oden: '51',
		resecentrum: '44',
		resfeber: '21',
		resia: '61',
		sas: '57',
		seat24: '4',
		sembo: '65',
		supersaver: '5',
		ticket: '43',
		travel2be: '54',
		travelgenio: '53',
		travelstart: '1',
		travelstore: '14',
		tripsta: '52'
	},
	uniqueAirportArrivals: [
		{
			airport: 'City',
			city: 'London',
			country: 'Storbritannien',
			iata: 'LCY',
			latitude: '51.50527',
			longitude: '0.055278',
			utc: '+00:00'
		}
	],
	uniqueAirportDepartures: [
		{
			airport: 'Arlanda',
			city: 'Stockholm',
			country: 'Sverige',
			iata: 'ARN',
			latitude: '59.65194',
			longitude: '17.91861',
			utc: '+01:00'
		}
	],
	uniqueAirportStops: [
		{
			airport: 'Landvetter',
			city: 'G\u00F6teborg',
			country: 'Sverige',
			iata: 'GOT',
			latitude: '57.66283',
			longitude: '12.27981',
			utc: '+01:00'
		}
	],
	uniqueAlliances: [
		'star alliance',
		'oneworld alliance',
		'skyteam alliance'
	],
	uniqueNumStops: [
		0,
		1,
		2
	],
	uniquePaymentMethods: [
		'visa',
		'master',
		'american express',
		'faktura/avbetalning',
		'direktbetalning-internetbank',
		'diners',
		'paypal',
		'bitcoin'
	],
	uniquePaymentMethodsId: {
		1: 'visa',
		2: 'master',
		3: 'american express',
		4: 'faktura/avbetalning',
		5: 'direktbetalning-internetbank',
		7: 'diners',
		8: 'paypal',
		9: 'bitcoin'
	},
	uniquePrices: [
		673,
		16281
	],
	uniqueTimes: [
		{
			arrivals: [
				1478677200,
				1478780700
			],
			departures: [
				1478664600,
				1478721600
			]
		},
		{
			arrivals: [
				1478767800,
				1478879100
			],
			departures: [
				1478754000,
				1478808300
			]
		}
	],
	uniqueTimesOffset: [
		{
			departures: [
				21900,
				24300
			],
			arrivals: [
				43800,
				46200
			]
		},
		{
			departures: [
				22800,
				23700
			],
			arrivals: [
				39900,
				43800
			]
		}
	],
	uniqueTraveltimes: [
		16800,
		167100
	],
	uniqueWaittime: [
		1800,
		82200
	],
	uniqueMaxTraveltimePerTrip: [
		9600,
		105600
	]
};
